export const Records = [
    {
        nombre: 'hola',
        fecha: '01/07/2024',
        duracion: '02:35:34'
    },
    {
        nombre: "Reunión de equipo",
        fecha: "27/04/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Entrenamiento",
        fecha: "28/04/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Presentación de proyecto",
        fecha: "29/04/2024",
        duracion: "02:15:00"
    },
    {
        nombre: "Llamada con cliente",
        fecha: "30/04/2024",
        duracion: "00:45:00"
    },
    {
        nombre: "Entrevista de trabajo",
        fecha: "01/05/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Sesión de entrenamiento",
        fecha: "02/05/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Revisión de código",
        fecha: "03/05/2024",
        duracion: "02:00:00"
    },
    {
        nombre: "Almuerzo con colegas",
        fecha: "04/05/2024",
        duracion: "01:15:00"
    },
    {
        nombre: "Presentación de ventas",
        fecha: "05/05/2024",
        duracion: "01:45:00"
    },
    {
        nombre: "Reunión de planificación",
        fecha: "06/05/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Conferencia virtual",
        fecha: "07/05/2024",
        duracion: "02:30:00"
    },
    {
        nombre: "Sesión de brainstorming",
        fecha: "08/05/2024",
        duracion: "01:15:00"
    },
    {
        nombre: "Entrenamiento de habilidades blandas",
        fecha: "09/05/2024",
        duracion: "02:00:00"
    },
    {
        nombre: "Entrevista de cliente",
        fecha: "10/05/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Reunión de seguimiento",
        fecha: "11/05/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Presentación de informe",
        fecha: "12/05/2024",
        duracion: "02:00:00"
    },
    {
        nombre: "Taller de desarrollo personal",
        fecha: "13/05/2024",
        duracion: "01:45:00"
    },
    {
        nombre: "Sesión de preguntas y respuestas",
        fecha: "14/05/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Entrenamiento de liderazgo",
        fecha: "15/05/2024",
        duracion: "02:15:00"
    },
    {
        nombre: "Revisión de presupuesto",
        fecha: "16/05/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Reunión de planificación estratégica",
        fecha: "17/05/2024",
        duracion: "02:30:00"
    },
    {
        nombre: "Entrevista de medios",
        fecha: "18/05/2024",
        duracion: "01:15:00"
    },
    {
        nombre: "Sesión de resolución de problemas",
        fecha: "19/05/2024",
        duracion: "02:00:00"
    },
    {
        nombre: "Almuerzo de equipo",
        fecha: "20/05/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Entrenamiento de productividad",
        fecha: "21/05/2024",
        duracion: "02:00:00"
    },
    {
        nombre: "Presentación de resultados",
        fecha: "22/05/2024",
        duracion: "01:45:00"
    },
    {
        nombre: "Reunión de retroalimentación",
        fecha: "23/05/2024",
        duracion: "01:30:00"
    },
    {
        nombre: "Sesión de tutoría",
        fecha: "24/05/2024",
        duracion: "01:00:00"
    },
    {
        nombre: "Conferencia de industria",
        fecha: "25/05/2024",
        duracion: "02:30:00"
    },
    {
        nombre: "Sesión de trabajo en equipo",
        fecha: "26/05/2024",
        duracion: "01:15:00"
    }
]